export default "/fonts/vendor/@fontsource/inter/files/inter-all-400-normal.woff?e71ac35377dd87cb4d4ba1817797552d";